import { Button, ButtonVariant, Dialog, InputField, Theme } from "@in/component-library";
import React, { ChangeEvent, FC, useEffect, useRef } from "react";
import { useLayout } from "../../hooks/use-layout";

interface UpdateEmailComponentProps {
  email: string;
  emailError?: string;
  isSaving: boolean;
  onClose: () => void;
  displayEmailModal: boolean;
  submit: () => void;
  updateEmail: (e: ChangeEvent<HTMLInputElement>) => void;
}

const UpdateEmail: FC<UpdateEmailComponentProps> = ({
  email,
  emailError,
  isSaving,
  onClose,
  displayEmailModal,
  submit,
  updateEmail
}) => {
  const { translations } = useLayout();

  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (emailError) {
      inputRef.current?.focus();
    }
  }, [emailError]);

  const ref = useRef<HTMLDialogElement>(null);

  if (displayEmailModal) {
    ref?.current?.showModal();
  } else {
    ref?.current?.close();
  }

  return (
    <Dialog
      className="email__modal"
      ref={ref}
      title={translations.changeEmailAdress}
      closeButton={{
        "aria-label": translations.close,
        onClick: () => {
          onClose();
        }
      }}
    >
      <div className="email__email-input">
        <InputField
          aria-live="assertive"
          className="data-hj-suppress"
          name="email"
          label={translations.changeEmailAdressLabel}
          onChange={updateEmail}
          value={email}
          errorMsg={emailError}
          ref={inputRef}
        />
      </div>

      <div aria-live="polite" className="email__button">
        <Button
          type="submit"
          variant={ButtonVariant.Solid}
          theme={Theme.Neutral}
          isLoading={isSaving}
          disabled={isSaving}
          onClick={submit}
        >
          {translations.verifiedNextBtnLabel}
        </Button>
        <Button variant={ButtonVariant.Outlined} onClick={onClose}>
          {translations.cancelBtnLabel}
        </Button>
      </div>
    </Dialog>
  );
};

export default UpdateEmail;
